import { colors, fontStyle } from "Constants";

export const searchBarStyle = {
  borderBottom: `1px solid ${colors.neutral600}`,
  fontSize: "2rem",
  paddingBottom: "8px",
  height: "36px",
};

export const inputTextStyle = {
  color: colors.neutral200,
  fontStyle: fontStyle.demiBold,
};

export const buttonContainerStyle = {
  fontStyle: fontStyle.bold,
};
